import { JSX } from "react";

import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";

export type LogoElement = {
  logoSrc: string;
  onClick?: () => void;
  imgSx?: object;
};

interface LogoAreaProps {
  logoArea: LogoElement[];
}

export default function LogoArea({ logoArea }: LogoAreaProps): JSX.Element {
  return (
    <Box sx={{ display: "flex", flexBasis: 0 }}>
      {logoArea.map((logo) => (
        <CardMedia
          key={logo.logoSrc}
          component="img"
          sx={{
            height: "7rem",
            width: "7rem",
            cursor: logo.onClick ? "pointer" : "default",
            objectFit: "contain",
            ...logo.imgSx,
          }}
          image={logo.logoSrc}
          alt={logo.logoSrc}
          onClick={logo.onClick}
        />
      ))}
    </Box>
  );
}
